import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MenuDisplayStatus } from '../../../app/services/api/range';

const colorByStatus: Record<MenuDisplayStatus, 'default' | 'success' | 'info' | 'warning'> = {
  [MenuDisplayStatus.Draft]: 'default',
  [MenuDisplayStatus.Scheduled]: 'info',
  [MenuDisplayStatus.Active]: 'success',
  [MenuDisplayStatus.Expired]: 'warning',
};

export const MenuDisplayStatusChip = ({ status }: { status: MenuDisplayStatus }) => {
  const { t } = useTranslation('range');
  return (
    <Chip
      size="small"
      color={colorByStatus[status]}
      label={t(`displayStatus${status}`)}
    />
  );
};
